import type { PollVoter } from '@/containers/DevToolsNew/CommunicationBoard/PollResults/types'
import PollVoterRow from './PollVoterRow/PollVoterRow'
import { VoterTable } from './styled-components'

interface PollVoterListProps {
  voters: PollVoter[]
  hidden: boolean
}

const PollVoterList = ({ voters, hidden }: PollVoterListProps) => {
  if (hidden) {
    return null
  }

  return (
    <VoterTable>
      {voters.map(voter => (
        <PollVoterRow key={voter.id} voter={voter} />
      ))}
    </VoterTable>
  )
}

export default PollVoterList
